(function() {
    'use strict';
    angular.module('wamasysApp').controller('AiCostsController', ['$http', 'AlertService', function($http, AlertService) {
        var vm = this;
        vm.data = {settings: {}, prices: [], warnings: [], recentUsage: []};
        vm.loading = false;
        vm.saving = false;
        vm.price = null;
        vm.resolution = null;
        vm.load = load;
        vm.saveSettings = function() { save('/settings', vm.data.settings); };
        vm.editPrice = function(price) { vm.price = angular.copy(price || {provider: 'openai', model: '', enabled: true}); };
        vm.savePrice = function() { save('/prices', vm.price); };
        vm.resolveUsage = function(row) { vm.resolution = {id: row.id, costUsd: row.estimatedCostUsd, note: ''}; };
        vm.saveResolution = function() {
            vm.saving = true;
            $http.post('/api/admin/ai-costs/usage/' + vm.resolution.id + '/resolve', vm.resolution).then(function() {
                vm.resolution = null; load();
            }).catch(error).finally(function() { vm.saving = false; });
        };
        vm.priceStatus = function(price) {
            if (!price.enabled) { return 'Désactivé'; }
            if (!price.verifiedOn || price.inputUsdPerMillion == null || price.cachedInputUsdPerMillion == null || price.outputUsdPerMillion == null) { return 'Tarif manquant — appels bloqués'; }
            if (price.provider === 'ollama') { return 'Local — 0 USD fournisseur'; }
            var verified = new Date(price.verifiedOn + 'T00:00:00');
            var today = new Date(); today.setHours(0, 0, 0, 0);
            return Math.round((today.getTime() - verified.getTime()) / 86400000) > vm.data.settings.staleAfterDays ? 'À vérifier — tarif ancien' : 'À jour';
        };
        vm.usageStatus = function(status) {
            return {RESERVED: 'Réservé / en cours', SETTLED: 'Mesuré', UNCERTAIN: 'Coût incertain', REJECTED: 'Refusé — 0 USD', RESOLVED: 'Régularisé'}[status] || status;
        };
        vm.canResolve = function(row) { return row.status === 'UNCERTAIN' || (row.status === 'RESERVED' && new Date(row.createdAt).getTime() < Date.now() - 7200000); };
        function save(path, data) {
            vm.saving = true;
            $http.put('/api/admin/ai-costs' + path, data).then(function() {
                vm.price = null; vm.message = 'Paramétrage enregistré.'; load();
            }).catch(error).finally(function() { vm.saving = false; });
        }
        function load() {
            vm.loading = true;
            $http.get('/api/admin/ai-costs').then(function(response) { vm.data = response.data; })
                .catch(error).finally(function() { vm.loading = false; });
        }
        function error(response) {
            AlertService.error((response.headers && response.headers('X-wamasysApp-error')) || 'Impossible de traiter le paramétrage des coûts IA.');
        }
        load();
    }]);
})();
